import React, { useEffect } from "react"
import { AppModal } from "@components"
import { reports, searchID } from "@signals"
import { openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { isEmpty } from "@ui-seeker/utils"
import AnalyzerEvolutionChart from "Pages/AnalyzersV2/@components/EvolutionModal/Chart"
import AnalyzerEvolutionChartActions from "Pages/AnalyzersV2/@components/EvolutionModal/ChartActions"
import useEvolutionModalData from "Pages/AnalyzersV2/@components/EvolutionModal/@hooks/useData"
import AnalyzerExecutionInfo, { hasExecutionInfo } from "Pages/AnalyzersV2/@components/ExecutionInfo"


export default function AnalyzerEvolutionModal({ isRating = false }) {
	const { onSubmit, isLoading, keySeries, chartData, setIsVisible, setIsLoading, officeData, executionDateTime } = useEvolutionModalData()

	useEffect(() => {
		if (!isEmpty(openEvolutionModal.value)) onSubmit()
	}, [openEvolutionModal.value])


	return <AppModal
		isOpen={!isEmpty(openEvolutionModal.value)}
		controller={() => openEvolutionModal.value = {}}
		title="Evolution Chart"
		icon="chart-line"
		subtitle={!searchID.value && !!reports.value && hasExecutionInfo(officeData, executionDateTime) && <AnalyzerExecutionInfo officeData={officeData} executionDateTime={executionDateTime} fontSize={13}/>}
		headerActions={<AnalyzerEvolutionChartActions setIsVisible={setIsVisible} setIsLoading={setIsLoading}/>}
		containerProps={{ fullScreen: true, sx: {
			'.MuiDialogContent-root': { px: 3, pt: 0, pb: 2 },
			'.MuiDialogContent-root .MuiCard-root': { border: 'none', boxShadow: 'none', borderRadius: 0 },
		}}}
		hideActions
	>
		<AnalyzerEvolutionChart
			chartData={chartData}
			keySeries={keySeries}
			isLoading={isLoading}
			isRating={isRating}
		/>
	</AppModal>
}
